import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import config from "../../../../../../config";

const formatAverageCryptoRSI = (value) => {
  const number = Number(value);

  if (!Number.isFinite(number)) {
    return "--";
  }

  return number.toFixed(2);
};

const normalizeAverageCryptoRSIValue = (data) => {
  const number = Number(data?.value);

  return Number.isFinite(number) ? number : null;
};

export const useAverageCryptoRSI = () => {
  const [averageCryptoRSI, setAverageCryptoRSI] = useState(null);
  const [isAverageCryptoRSILoading, setIsAverageCryptoRSILoading] =
    useState(true);

  useEffect(() => {
    const fetchAverageCryptoRSI = async () => {
      try {
        setIsAverageCryptoRSILoading(true);

        const response = await axios.get(
          `${config.api_url}/coinmarketcap/average-rsi`,
        );

        setAverageCryptoRSI(
          normalizeAverageCryptoRSIValue(response.data),
        );
      } catch (error) {
        console.error("Failed to fetch Average Crypto RSI data", error);
        setAverageCryptoRSI(null);
      } finally {
        setIsAverageCryptoRSILoading(false);
      }
    };

    fetchAverageCryptoRSI();
  }, []);

  const formattedAverageCryptoRSI = useMemo(
    () => formatAverageCryptoRSI(averageCryptoRSI),
    [averageCryptoRSI],
  );

  return {
    averageCryptoRSI,
    formattedAverageCryptoRSI,
    isAverageCryptoRSILoading,
  };
};